export default {
  candidates(state) {
    return state.candidates
  },
  candidate(state) {
    return state.candidate
  },
  candidatesFilters(state) {
    return state.candidatesFilters
  },
  candidatesRules(state) {
    return state.candidatesRules
  },
}
